import React from 'react';
import { connect } from 'react-redux';
import { CHANGE_IMPACT_ROLES } from '../../constants/employeeProfile.js';
import { selectEmployee } from '../../modules/employees.js';
import EmployeeProfileHeaderContainer from './EmployeeProfileHeaderContainer.jsx';
import EmployeeChangeImpactsSectionContainer from './EmployeeChangeImpactsSectionContainer.jsx';

const mapStateToProps = (state, ownProps) => ({
  employeeLoaded: Boolean(selectEmployee(ownProps.employeeId)(state)),
});

// Change Impacts tab of the employee profile
const EmployeeChangeImpactsContainer = ({
  employeeId,
  search,
  employeeLoaded,
}) => (
  <React.Fragment>
    <EmployeeProfileHeaderContainer employeeId={employeeId} />
    {/* sections fetch right away, but render under the header once it is loaded */}
    <div style={employeeLoaded ? undefined : { display: 'none' }}>
      <EmployeeChangeImpactsSectionContainer
        employeeId={employeeId}
        role={CHANGE_IMPACT_ROLES.OWNER}
        title="Owner"
        emptyMessage="Employee doesn’t own any change impacts yet."
        search={search}
      />
      <EmployeeChangeImpactsSectionContainer
        employeeId={employeeId}
        role={CHANGE_IMPACT_ROLES.IMPACTED}
        title="Impacted"
        emptyMessage="Employee isn’t impacted by any change impacts yet."
        search={search}
      />
    </div>
  </React.Fragment>
);

export default connect(mapStateToProps)(EmployeeChangeImpactsContainer);
